import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { CenterFrameLayout } from 'Layouts';
import { ShippingForm } from 'Forms/ShippingForm';
import { FinePrint } from 'Components/Texts';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { Navigate, useNavigate } from 'react-router-dom';
import { updateShippingAddress } from 'State/Checkout';
import { useStore } from 'Hooks/useStore';
import './ShippingContainer.css';

export const ShippingComponent = ({ isPlanSelected, hasSubscription }) => {
  const navigate = useNavigate();
  const routes = useStore('appConfig.routes');

  const onShippingFormSubmit = (address) => {
    updateShippingAddress(address);
    navigate(routes.payment);
  };

  useEffect(() => {
    trackEvent(TRACKING_ENUMS.EVENT_SHIPPING_FORM_STARTED);
    return function shippingCompleted() {
      trackEvent(TRACKING_ENUMS.EVENT_SHIPPING_FORM_COMPLETED);
    };
  }, []);

  if (!isPlanSelected) {
    if (hasSubscription) {
      return <Navigate replace to={routes.changePlans} />;
    }
    return <Navigate replace to={routes.signupPlans} />;
  }

  return (
    <CenterFrameLayout title="Enter your shipping address" customClass="shippingContainer">
      <div className="roundContentContainer">
        <ShippingForm onFormSubmit={onShippingFormSubmit} />
        <FinePrint
          className="shippingContainerFinePrint"
          text="Fox Nation Merchandise fulfillment begins upon trial period conclusion."
        />
      </div>
    </CenterFrameLayout>
  );
};

const mapStateToProps = ({ subscription: { hasSubscription }, plans: { isPlanSelected } }) => ({
  isPlanSelected,
  hasSubscription,
});
export const ShippingContainer = connect(mapStateToProps, {})(ShippingComponent);
